const getNoFiltersMessage = (type: string) => {
    return `No ${type}(s) conform to filters.`;
};

const getNoEntriesMessage = (type: string) => {
    return `You don’t have ${type}s yet. Please create a ${type}.`;
};
export {getNoFiltersMessage, getNoEntriesMessage};
